import { AppointmentPaymentRules } from '../estabelecimento/Form/AsaasPayments';

export default function PagamentosConfiguracao() {
    return (
        <div className="sf-page mx-auto max-w-2xl px-2">
            <AppointmentPaymentRules />
        </div>
    );
}
